import {
  Box,
  Text,
  VStack,
  HStack,
  Collapse,
  Input,
  IconButton,
  Badge,
  Flex,
  useDisclosure,
  Button
} from "@chakra-ui/react"

import { useState, useMemo, useRef, useCallback } from "react"
import  ResultList from "./ResultList"
import { ResultListDto } from "../../../../Api/client/ResultClient"

interface Props {
  lists: ResultListDto[]
}

export default function ResultsView({ lists }: Props) {
  const rowRefs = useRef<Record<string, HTMLDivElement | null>>({})


  return (
    <Box maxW="900px" mx="auto" >
      {/* RESULT LISTS */}

      <VStack spacing={4} mt={3} align="stretch">
        {lists.map((list, li) => (
          <ResultList
            key={list.name}
            list={list}
            listIndex={li}
            rowRefs={rowRefs}
          />
        ))}
      </VStack>
    </Box>
  )
}
